import './CompletePage.css';

export default function CompletePage({ totalCount }) {
  return (
    <div className="complete-page">
      <div className="complete-card">
        <div className="complete-icon">✓</div>
        <h1 className="complete-title">答题完成</h1>
        <p className="complete-desc">
          您已完成全部 {totalCount} 道题目，感谢您的参与！
        </p>
      </div>
    </div>
  );
}
